import(/* webpackMode: "eager" */ "/codebuild/output/src2131828011/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/error.tsx");
